module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00012-4654d79d7beb7104dd98b6d4d4917ca1.jpg";